import React, { Component } from 'react';

export class PrevDialog extends Component {
  resolve;

  state = { 
    display: "dnone", 
    href: ""
  }

  close =()=> {
    this.setState({ display: "dnone" });
  }

  show = async (href) => {
    const fileType = this.getType(href);

    if(fileType == "blob") {
      window.location.href = href;
    }
    else {
      this.setState({
        href,
        display: "dblock"
      })
    }

    return new Promise(rs => this.resolve = rs)
  }

  save =e=> {
    if(!this.state.row.predmetPozadavku) {
      this.setState({ error: true});
      return
    }

    this.close();
    this.resolve(this.state.row);
    this.setState({ error: false });
  }

  preview =href=> {
    this.setState({ href: href});
  }

  cancel =e=> {
    if(e.target.id == "PrevDialog" || e.target.id == "zrusit" || e.target.className == "close") {
      this.close();
      this.resolve(false);
    }
  }

  close =()=> {
    this.setState({ 
      display: "dnone", 
      href: "" 
    });
  }

  getType(href) {
    const ext = href.split(".").pop().toLowerCase();
    if(!ext) return "blob";

    const types = {
      image: ["jpg", "jpeg", "bmp", "webp", "gif", "png", "ico", "svg"],
      video: ["mpg", "avi", "mp4", "mkv", "mpeg", "vob"],
      text: ["txt", "json", "html", "js", "ini"],
      pdf: ["pdf"],
    }

    return Object.keys(types).find(key => types[key].includes(ext)) || "blob";
  }

  createPreview() {
    const href = this.state.href.replace("/detail/", "/nahled/");
    const ext = href.split(".").pop().toLowerCase();
    if(!ext) return [];

    const type = this.getType(href);

    switch(type) {
      case "image": return <img src={href}></img>
      case "pdf": return <embed src={href} type="application/pdf" />
      case "video": return <video src={href} />
      case "text": return <iframe src={href}></iframe>
    }

    this.setState({ href: "" });
    return [];
  }

  download=()=> {
    window.location.href = this.state.href;
  }

  viewPrev=()=> {
    window.open(this.state.href.replace("/detail/", "/nahled/"), '_blank').focus();
  }

  render() {
    const s = this.state;

    return (
      <div className={"modal " + s.display} id="PrevDialog" onClick={this.cancel}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal">×</button>
              <h4 className="modal-title">Náhled souboru</h4>
            </div>
            <div className="modal-body">
              <div id="nahled">
                {this.createPreview()}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" id="stahnout" onClick={this.download}>Stáhnout</button>
              <button className="btn btn-success" id="zobrazit" onClick={this.viewPrev}>Zobrazit</button>
              <button className="btn btn-warning" id="zpet" onClick={this.close}>Zpět</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}